import { useContext, useState } from "react";
import { SelectedServiceContext } from "@context/ISelectedContext";
import { useForm } from "react-hook-form";
import { getOrderSimRoute } from "@api-routes/eirCustomersFacade";
import { IUserDetailsInfo } from "../../Profile/interface/IUserDetails";
import { getStateToPayload } from "../mappers/postReplacementSimMapper";
import { IUserAddress } from "@common/Eircode/interface/IAddressForm";
import { useFetch } from "@common/hook/useFetch";

export const useReplacementSimForm = (deliveryAddress?: IUserAddress, userDetails?: IUserDetailsInfo) => {
    const { selectedService } = useContext(SelectedServiceContext);
    const [postReplacementSimState, { post }] = useFetch();
    const [barPreviousSim, setBarPreviousSim] = useState(false);

    const formMethods = useForm<IUserAddress>({ defaultValues: deliveryAddress });

    const postReplacementSim = (formData: IUserAddress) => {
        if (selectedService && userDetails) {
            return post<boolean>(getOrderSimRoute(), {
                body: getStateToPayload(formData, barPreviousSim, userDetails, selectedService),
                forwardError: true,
            });
        }

        return undefined;
    };

    const postReplacementSimInitial = (
        formData: IUserAddress,
        openErrorModal: (userAddress: IUserAddress) => void,
        onSuccessCallback: () => void
    ) => {
        const postReplacementSimResult = postReplacementSim(formData);

        if (postReplacementSimResult) {
            postReplacementSimResult
                .then((isSubmitted) => {
                    if (isSubmitted) {
                        onSuccessCallback();
                    }
                })
                .catch(() => {
                    openErrorModal(formData);
                });
        }
    };

    const postReplacementSimAfterError = (
        closeErrorModal: () => void,
        onSuccessCallback: () => void,
        userAddress?: IUserAddress
    ) => {
        if (userAddress) {
            const postReplacementSimResult = postReplacementSim(userAddress);

            if (postReplacementSimResult) {
                postReplacementSimResult.then((isSubmitted) => {
                    if (isSubmitted) {
                        closeErrorModal();
                        onSuccessCallback();
                    }
                });
            }
        }
    };

    return {
        barPreviousSim,
        setBarPreviousSim,
        postReplacementSimAfterError,
        postReplacementSimInitial,
        postReplacementSimState,
        formMethods,
    };
};
